import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>About OptiPathway</h1>
        <p>
          OptiPathway is a powerful and intuitive web application designed to help you find the most efficient route between multiple locations.
          Whether you're planning deliveries, a road trip, or simply optimizing your daily errands, OptiPathway leverages advanced routing algorithms
          to provide you with the best possible sequence of stops, saving you time and fuel. This involves solving a variant of the classic Traveling Salesperson Problem (TSP) to ensure optimal efficiency.
        </p>
        <p>
          Our goal is to provide a seamless and efficient route optimization experience, making complex logistics simple and accessible for everyone.
        </p>
        <br />
        <h2>Use Cases</h2>
        <p>OptiPathway is ideal for a variety of applications, including:</p>
        <ul>
          <li>
            <strong>Delivery Services:</strong> Optimize routes for multiple delivery stops, ensuring that your drivers take the most efficient path. This can help reduce fuel costs and delivery times, improving overall customer satisfaction.
          </li>
          <li>
            <strong>Road Trip Planning:</strong> Plan your multi-stop road trip with ease. Enter all your desired destinations, and OptiPathway will determine the optimal order to visit them, minimizing travel time and making your journey more enjoyable.
          </li>
          <li>
            <strong>Logistics and Field Services:</strong> For businesses that require staff to visit multiple locations, such as sales, maintenance, or support services, OptiPathway can create optimized daily schedules. This ensures that your team spends less time on the road and more time with clients.
          </li>
        </ul>
        <br />
        <Link to="/">Back to Optimizer</Link>
      </header>
    </div>
  );
}

export default About;
